import { render, staticRenderFns } from "./KBAUpdate.vue?vue&type=template&id=5e957eed"
import script from "./KBAUpdate.vue?vue&type=script&lang=js"
export * from "./KBAUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports